import React from 'react';
import styled from 'styled-components';

const FreeBreakfastTag = ({text}: {text: string}) => (
  <WrapperDiv>
    <TagMarkup />
    <TextWrapperSpan>{text}</TextWrapperSpan>
  </WrapperDiv>
);

export default FreeBreakfastTag;

const WrapperDiv = styled.div(
  props => `
  position: absolute;
  left:${props.theme.spacing.custom(7)};
  top: ${props.theme.spacing.custom(25)};
  background-color: ${props.theme.colors.goGreen.base};
  border-radius: ${props.theme.misc.borderRadius.small};
  padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.custom(4)}
    ${props.theme.spacing.xsmall} ${props.theme.spacing.custom(8)};
`,
);

const TextWrapperSpan = styled.span(
  props => `
  font-weight: bold;
  color: ${props.theme.colors.goWhite.base};
`,
);

const TagMarkup = styled.div(
  props => `
  &:after {
    content: '';
    border-top: 0.5rem solid ${props.theme.colors.goGreen.base};
    border-left: 0.5rem solid transparent;
    position: absolute;
    left: 0;
    top: 1.8rem;
  }
`,
);
